import axios from "axios";
// eslint-disable-next-line
import React, { useContext, useEffect, useState } from "react";
import summaryApi from "../common/Api";
import { toast } from "react-toastify";
import Loading from "../components/loading/loading";
import { MdDeleteOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import addToCart from "../helpers/addToCart";
import UserContext from "../context/context";
import { FiShoppingBag } from "react-icons/fi";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import Cookies from "js-cookie";

const WishList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clicked, setClicked] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const { fetchCartCount } = useContext(UserContext);

  const fetchWishListData = async () => {
     const tokenApi = Cookies.get("tokenApi");
    try {
      const response = await axios.get(summaryApi.wishlistProductList.url,{
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
        withCredentials: true,
      });
      const fetchedData = response?.data?.data?.items || [];
      // console.log("fetchWishListData", response?.data?.data);
      setData(response?.data?.data?.items);
      return fetchedData;
    } catch (error) {
      console.error("Error fetching wishlist data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // const removeProduct = async (productId) => {
  //   setClicked(true);
  //   try {
  //   const tokenApi = Cookies.get("tokenApi");
  //   if (!tokenApi) {
  //           toast.error("Please login first!", {
  //             position: "bottom-center",
  //             className: "custom-toast",
  //             autoClose: 2000,
  //             draggable: true,
  //             hideProgressBar: true,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggablePercent: 60,
  //           });
  //           return;
  //         }

  //     await axios.delete(summaryApi.deleteWishlistProduct.url, {
  //       data: { productId },
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${tokenApi}`,
  //       },
  //       withCredentials: true,
  //     });
  //     setClicked(false);

  //     setData((prevData) => prevData.filter((item) => item?._id !== productId));
  //     toast.success("Product removed from wishlist!", {
  //       position: "bottom-center",
  //       className: "custom-toast",
  //       autoClose: 2000,
  //       draggable: true,
  //       hideProgressBar: true,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggablePercent: 60,
  //     });
  //   } catch (error) {
  //     console.error("Error removing product:", error);
  //     toast.error("Failed to remove product.", {
  //       position: "bottom-center",
  //       className: "custom-toast",
  //       autoClose: 2000,
  //       draggable: true,
  //       hideProgressBar: true,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggablePercent: 60,
  //     });
  //   } finally {
  //     // setClicked(false);
  //   }
  // };
  const removeProduct = async (productId) => {
    setClicked(true);
    try {
      const tokenApi = Cookies.get("tokenApi");
      if (!tokenApi) {
        toast.error("Please login first!", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
        return;
      }
  
      await axios.delete(summaryApi.deleteWishlistProduct.url, {
        data: { productId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenApi}`,
        },
        withCredentials: true,
      });
      setData((prevData) => prevData.filter((item) => item._id !== productId));
      // setData((prevData) => {
      //   if (!Array.isArray(prevData)) {
      //     console.error("prevData is not an array:", prevData);
      //     return [];
      //   }
      //   return prevData.filter((item) => item?._id !== productId);
      // });
  
      toast.success("Product removed from wishlist!", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } catch (error) {
      console.error("Error removing product:", error);
      toast.error("Failed to remove product.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } finally {
      setClicked(false);
    }
  };
  
  useEffect(() => {
    fetchWishListData();
  }, []);

  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  const handleAddToCart = async (e, productId) => {
    setIsClicked(true);
    try {
      await addToCart(e, productId);
      fetchCartCount();
    } catch (error) {
      console.error("Error adding product to cart:", error);
    } finally {
      setIsClicked(false);
    }
  };

  return (
    <div className="container mx-auto p-4">
      {data.length > 0 && (
        <h2
          className="text-2xl font-bold my-7 uppercase"
          style={{ fontFamily: "serif" }}
        >
          Your Wishlist
        </h2>
      )}

      {data.length === 0 && !loading && (
        <div className="flex justify-center items-center text-center animate-pulse">
          <img
            src="https://adasglobal.com/img/empty-cart.png"
            alt="Empty Wishlist"
            className="w-full md:w-[50%] h-auto object-contain mix-blend-multiply"
            loading="lazy"
          />
        </div>
      )}

      <div className="flex flex-wrap gap-5">
        {data?.map((item) => (
          <Link
            to={`/product/${item?.product?._id}`}
            key={item?.product?._id}
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
            className="w-full md:w-[calc(33.333%-1.25rem)] shadow-md rounded-md overflow-hidden mb-4"
          >
            <div className="relative h-48 p-4 bg-slate-200">
              <img
                src={item?.product?.product_image?.[0] || ""}
                alt={item?.product?.name || "Product Image"}
                className="w-full h-full object-scale-down mix-blend-multiply hover:scale-110 duration-300"
                loading="lazy"
              />
              <button
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  removeProduct(item?._id);
                }}
                disabled={clicked}
                className="absolute top-2 left-2 text-2xl text-red-500 hover:text-red-700"
              >
                <MdDeleteOutline />
              </button>
            </div>

            <div className="p-4 bg-white grid gap-2">
              <h2 className="font-semibold text-ellipsis line-clamp-1">
                {item?.product?.name}
              </h2>
              <p className="text-sm text-gray-500 capitalize">
                {item?.product?.category}
              </p>

              <div className="flex flex-row gap-2">
                <FaStar className="text-yellow-400" />
                <FaStar className="text-yellow-400" />
                <FaStar className="text-yellow-400" />
                <FaStar className="text-yellow-400" />
                <FaStarHalfAlt className="text-yellow-400" />
              </div>

              <div className="flex gap-3 items-center my-2">
                {item?.product?.discount > 0 ? (
                  <div className="flex flex-row gap-3 items-center">
                    <p className="text-[#6fdedc] font-bold ">
                      ${item?.product?.discount}
                    </p>
                    <p className="text-gray-500  line-through">
                      ${item?.product?.price}
                    </p>
                  </div>
                ) : (
                  <p className="text-[#6fdedc] font-bold">
                    ${item?.product?.price}
                  </p>
                )}
              </div>
              <p className="text-gray-700 text-lg font-semibold">
                Stock: {item?.product?.quantity}
              </p>
            </div>

            {item?.product?.quantity > 0 ? (
              <button
                disabled={isClicked}
                className="bg-slate-100 w-full h-10 rounded flex items-center justify-center  hover:bg-main-background py-1 px-3 transition-all hover:animate-pulse hover:text-white hover:font-bold"
                onClick={(e) => handleAddToCart(e, item?.product?._id)}
              >
                {" "}
                <span className="text-lg flex items-center mx-auto justify-between gap-2">
                  <p className="text-base text-slate-400 font-bold hover:text-white px-1 transition-all duration-300">
                    Add To Cart
                  </p>
                  <FiShoppingBag className="text-slate-500" />
                </span>{" "}
              </button>
            ) : (
              <button
                disabled
                className="w-full text-white text-sm mt-1 font-semibold px-3 py-1 rounded-full bg-red-500"
              >
                Out of Stock
              </button>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default WishList;
